import CurrentPage from "./CurrentPage";
import TotalPage   from "./TotalPage";

class Pagination {
  constructor(
    private readonly _current: CurrentPage = new CurrentPage(),
    private readonly _total: TotalPage = new TotalPage(),
  ) {
  }

  public next(): Pagination {
    return new Pagination(this._current.next(), this._total);
  }

  public prev(): Pagination {
    return new Pagination(this._current.prev(), this._total);
  }

  public isLast(): boolean {
    return this._current.value >= this._total.value;
  }

  get current() {
    return this._current;
  }

  get total() {
    return this._total;
  }
}

export default Pagination;
